
import { defineComponent, computed, ref, PropType } from 'vue';
import { domainStore } from '@/store/domain-store';
import { askusStore } from '@/store/askus-store';
import AskusAttributeBadges from '@/components/askus/AskusAttributeBadges.vue';
import useConverter from '@/composables/general/useConverter';
import useStringManip from '@/composables/general/useStringManip';
import { IAskusQuestion } from '@/models/askus.model';
import { IAttributeValue } from '@/models/attribute.model';

export default defineComponent({
  //Prevents warning caused by the keep alive functionality.
  // Warnings included -> use of externious Props...etc
  inheritAttrs: false,
  name: 'AskusList',
  props: {
    questions: {
      type: Array as PropType<IAskusQuestion[]>,
      required: true,
    },
  },
  components: {
    AskusAttributeBadges,
  },
  emits: ['openQuestion'],
  setup(props, context) {
    const { truncateAfterWord } = useStringManip();
    const { formattedDate, toBool } = useConverter();

    const attributesShownAsColumns = computed(() => {
      const attrs = askusStore.getState().askus.attributes;
      return attrs.filter((x: any) => x.relation_data && x.relation_data.show_in_table === '1');
    });

    const attributesShownAsTags = computed(() => {
      const attrs = askusStore.getState().askus.attributes;
      return attrs.filter((x: any) => x.relation_data && x.relation_data.show_in_table === '2');
    });

    const canShowQuestionStatus = computed(() => {
      return toBool(askusStore.getState().askus.show_question_status);
    });

    const canShowQuestionDate = computed(() => {
      return toBool(askusStore.getState().askus.show_question_created);
    });

    function openQuestion(question: IAskusQuestion, questionid: number) {
      context.emit('openQuestion', question, questionid);
    }

    function getAttributeValueById(question: IAskusQuestion, attributeid: number) {
      const attr = question.attributes.find((x: IAttributeValue) => x.id == attributeid);
      if (attr == null || attr == undefined) {
        return '';
      }
      return attr.value_human;
    }

    return {
      domainStore,
      attributesShownAsTags,
      attributesShownAsColumns,
      canShowQuestionStatus,
      canShowQuestionDate,
      formattedDate,
      truncateAfterWord,
      openQuestion,
      getAttributeValueById,
    };
  },
});
